import { createContext, useContext } from "react";
var context = createContext(undefined);
context.displayName = "ConfigContext";
export var ConfigProvider = context.Provider;
export var useConfig = function () {
    var value = useContext(context);
    if (!value) {
        throw new Error("No config");
    }
    return value;
};
